





































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { ToHome } from "@/shared/route-names";
import CurrentEmployer from "./CurrentEmployer.vue";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useNavigationStore } from "@/shared/store/navigation";

@Component({
  components: { CurrentEmployer }
})
export default class Nav extends Vue {
  userStore = useUserStore();
  navigationStore = useNavigationStore();
  custodianSettingsStore = useCustodianSettingsStore();

  afterRoutedHook: any;

  @Prop()
  open: boolean;

  navItemActive = "";
  ToHome = ToHome;

  selectNavItem (itemName: string) {
    this.navItemActive = itemName;
  }

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  get userProfileLinkActive () {
    return this.navItemActive === "userProfile";
  }

  get dashboardLinkActive () {
    return this.navItemActive === "dashboard";
  }

  get employerLinkActive () {
    return this.navItemActive === "employerActions";
  }

  get reportsLinkActive () {
    return this.navItemActive === "reportActions";
  }

  get employeeLinkActive () {
    return this.navItemActive === "employeeActions";
  }

  get resourcesLinkActive () {
    return this.navItemActive === "resources";
  }

  get settingsLinkActive () {
    return this.navItemActive === "settings";
  }

  get displayInitials () {
    if (!this.userStore.currentUser.firstName || !this.userStore.currentUser.lastName) {
      // Whatever the default initials should be if you don't have a name
      return "NA";
    }

    return `${this.userStore.currentUser.firstName[0]}${this.userStore.currentUser.lastName[0]}`;
  }

  get currentUserEmail () {
    if (!this.userStore.currentUser.email) {
      return "guest";
    }

    return this.userStore.currentUser.email;
  }

  created () {
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getEmployerCustodian();
  }

  beforeDestroy () {
    this.afterRoutedHook();
  }
}

